import React from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
import { msalInstance, initializeMsalInstance } from './maslConfig';
import { SnackbarProvider } from 'notistack';
import { Provider } from 'react-redux';
import { store } from './reduxStore/store';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

const renderApp = async () => {
  try {
    // Initialize the MSAL instance
    await initializeMsalInstance();

    // Render the app after initialization
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <Provider store={store}>
            <SnackbarProvider maxSnack={3}>
              <App />
            </SnackbarProvider>
          </Provider>
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize MSAL instance:', error);
  }
};

renderApp();
